export class S3TemplateParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetBucketId",
            "baseName": "targetBucketId",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefixTemplate",
            "baseName": "prefixTemplate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3TemplateParams.attributeTypeMap;
    }
    constructor() {
    }
}
